import { Navigate, Outlet } from "react-router";

import FullLoadingScreen from "../../../components/FullLoadingScreen";

import { Box } from "@mui/material";
import { LangSwitcher } from "../../../components/lang-switcher";
import { useAuth } from "../AuthContext";

const ExcludedRoute = () => {
	const { loggedIn, user } = useAuth();

	if (loggedIn === null) {
		return <FullLoadingScreen />;
	}

	if (loggedIn === true && user && user.role) {
		if (user.role === "super-admin") {
			return <Navigate to="/admin" />;
		}
		return <Navigate to="/" />;
	}

	return (
		<>
			<Box sx={{ position: "absolute", top: 0, right: 0, p: 2 }}>
				<LangSwitcher />
			</Box>
			<Outlet />
		</>
	);
};

export default ExcludedRoute;
